var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9527 9.70413C18.206 10.0594 18.3327 10.237 18.3327 10.5C18.3327 10.7629 18.206 10.9405 17.9527 11.2958C16.8143 12.8921 13.907 16.3333 9.99935 16.3333C6.09167 16.3333 3.18443 12.8921 2.04605 11.2958C1.79269 10.9405 1.66602 10.7629 1.66602 10.5C1.66602 10.237 1.79269 10.0594 2.04605 9.70413C3.18443 8.10783 6.09167 4.66663 9.99935 4.66663C13.907 4.66663 16.8143 8.10783 17.9527 9.70413Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.5C12.5 9.11925 11.3807 8 10 8C8.61925 8 7.5 9.11925 7.5 10.5C7.5 11.8807 8.61925 13 10 13C11.3807 13 12.5 11.8807 12.5 10.5Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.971ac834bb072c31424038b8e1de0d19.svg";
export { ForwardRef as ReactComponent };